type Environment = "production" | "test" | "local";

declare global {
  const harcrm: {
    APP_VERSION: number;
    ENV: Environment;
  };
}
const productionHosts = ["aimode.har.com", "aisearch.har.com"];

const testHosts = [
  "aimode-test.har.com",
  "aimode-test1.har.com",
  "aimode-test2.har.com",
  "aimode-test3.har.com",
  "aisearch-test.har.com",
];

export const _environment: Environment = productionHosts.includes(
  window.location.host
)
  ? "production"
  : testHosts.includes(window.location.host)
  ? "test"
  : "local";

// Replace this variable to simulate a specific enviornment from local
export const environment = _environment;

export const isProduction = environment === "production";
export const isLocal = environment === "local";
export const isTest = environment === "test";

export const websiteProductionHost = "https://www.har.com";
export const websiteHost =
  process.env.REACT_APP_WEBSITE_URL ??
  (isProduction ? websiteProductionHost : "https://www-v2-test.har.com");
